@if (!addNewOta) {
  <div class="main-container">
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">OTA Master</span>
      </div>
      <!-- Redirect Button -->
      <div class="button-group">
        @if (createOta) {
          <button class="primary-button" (click)="addNewOTACommandFunc()">
            Add OTA Command
            <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
        }
      </div>
    </div>

    <div class="component-container">
      <!-- List Section -->
      <form [formGroup]="filterForm" novalidate>
        <div class="component-header">
          <h6 class="component-title">OTA Command List</h6>
          <div class="component-actions">
            <app-common-component-dropdown-search
              [items]="otaOverviewFilter"
              [initialValue]="filterForm?.get('filterSelected')?.value"
              [placeHolder]="'Select OTA Type'"
              (itemSelected)="filterSelected($event)"
            ></app-common-component-dropdown-search>
            <app-common-search
              [initialSearchValue]="filterForm?.get('filterSelected')?.value"
              matTooltip="OTA Command Name | OTA Command"
              (searchSubmit)="onSearch($event)"
            ></app-common-search>
          </div>
        </div>
      </form>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <div class="component-body">
        <table>
          <tr>
            <th>OTA Command Name</th>
            <th>OTA Command</th>
            <th>OTA Type</th>
            <th>Example</th>
            <th>Input Required</th>
            <th>Time Interval</th>
            <th>Created By</th>
            @if (updateOta || deleteOta) {
              <th>Action</th>
            }
          </tr>
          @if (otaItems.length !== 0) {
            <tbody>
              @for (
                item of otaItems
                  | paginate
                    : {
                        id: 'batchPaginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track item;
                let i = $index
              ) {
                <tr>
                  <td>
                    {{ item.name || '--' }}
                  </td>
                  <td>
                    {{ item.otaCommand || '--' }}
                  </td>
                  <td>
                    {{ item.otaType || '--' }}
                  </td>
                  <td>
                    {{ item.example || '--' }}
                  </td>
                  <td>
                    {{ item.isInputRequired ? 'Yes' : 'No' }}
                  </td>
                  <td>
                    {{ item.timeInMs || '--' }}
                  </td>
                  <td>
                    {{ item.createdBy?.fullName || '--' }}
                  </td>
                  <td>
                    <div class="action-buttons">
                      @if (updateOta) {
                        <button
                          type="button"
                          class="primary-button view-button"
                          (click)="updateData(i)"
                        >
                          <mat-icon class="btn-icon">visibility</mat-icon>
                        </button>
                      }
                      @if (deleteOta) {
                        <button
                          type="button"
                          class="primary-button delete-button"
                          (click)="deleteCommand(item)"
                        >
                          <mat-icon class="btn-icon">delete</mat-icon>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (otaItems.length === 0) {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        @if (totalLength !== 0) {
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size"
            [currentPage]="page"
            [totalPages]="totalLength"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  </div>
}
<!-- Add/edit OTA command -->
@if (addNewOta) {
  <div class="main-container">
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="cancelFunc()"
          tabindex="0"
          (keydown.enter)="cancelFunc()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="otaFormFill(index)"
          tabindex="0"
          (keydown.enter)="otaFormFill(index)"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">Add/Edit OTA Master</span>
      </div>
    </div>

    <div class="component-container">
      @if ((updateOta && UpdateOtaItem) || (createOta && !UpdateOtaItem)) {
        <!-- Form Section -->
        <form [formGroup]="otaMaster" novalidate>
          <div class="component-header">
            <h6 class="component-title">
              {{ UpdateOtaItem ? 'Update' : 'Add' }} OTA Command
            </h6>
          </div>

          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>

          <!-- Component Body Section -->
          <div class="component-body">
            <div class="form-section">
              <div class="form-group">
                <label for="name" class="form-label">OTA Command Name</label>
                <mat-form-field appearance="outline">
                  <mat-label>OTA Command Name</mat-label>
                  <input
                    matInput
                    id="name"
                    type="text"
                    placeholder="OTA Command Name"
                    formControlName="name"
                    required
                    #paramName
                  />
                  @if (
                    otaMaster.controls['name'].touched &&
                    otaMaster.controls['name'].errors?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        otaMaster.controls['name'].errors
                          ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <label
                  for="otaCommand"
                  class="form-label"
                  matTooltip="
                *SET#Example# ||
                *SET#Example#VAL# ||
                *SET#Example#VAL#VAL ||
                *GET#Example# ||
                *CLR#Example#"
                  >OTA Command</label
                >
                <mat-form-field appearance="outline">
                  <mat-label>OTA Command</mat-label>
                  <input
                    matInput
                    id="otaCommand"
                    type="text"
                    placeholder="OTA Command"
                    formControlName="otaCommand"
                    required
                  />
                  @if (
                    otaMaster.controls['otaCommand'].touched &&
                    otaMaster.controls['otaCommand'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        otaMaster.controls['otaCommand'].errors
                          ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <label for="" class="form-label">OTA Type</label>
                <mat-form-field appearance="outline">
                  <mat-label>OTA Type</mat-label>
                  <mat-select formControlName="otaType" required>
                    @for (value of otaTypeList; track value) {
                      <mat-option [value]="value">
                        {{ value }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (
                    otaMaster.controls['otaType'].touched &&
                    otaMaster.controls['otaType'].invalid
                  ) {
                    <mat-error> This field is mandatory. </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <label for="example" class="form-label">Example</label>
                <mat-form-field appearance="outline">
                  <mat-label>Example</mat-label>
                  <input
                    matInput
                    type="text"
                    id="example"
                    placeholder="Example"
                    formControlName="example"
                    required
                  />
                  @if (
                    otaMaster.controls['example'].touched &&
                    otaMaster.controls['example'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        otaMaster.controls['example'].errors
                          ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <label for="timeInMs" class="form-label"
                  >Time Interval (ms)</label
                >
                <mat-form-field appearance="outline">
                  <mat-label>Time Interval</mat-label>
                  <input
                    matInput
                    type="number"
                    id="timeInMs"
                    placeholder="Time Interval"
                    formControlName="timeInMs"
                    required
                  />
                  @if (
                    otaMaster.controls['timeInMs'].touched &&
                    otaMaster.controls['timeInMs'].errors?.required
                  ) {
                    <mat-error> This field is required. </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <label for="" class="form-label">Input Field Required</label>
                <mat-form-field appearance="outline">
                  <mat-label>Input Field Required</mat-label>
                  <mat-select formControlName="isInputRequired" required>
                    @for (value of InputFields; track value) {
                      <mat-option [value]="value">
                        {{ value }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (
                    otaMaster.controls['isInputRequired'].touched &&
                    otaMaster.controls['isInputRequired'].invalid
                  ) {
                    <mat-error> This field is mandatory. </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- Separator between Body and Footer -->
          <div class="component-separator"></div>

          <div class="component-footer">
            <div class="button-group">
              @if (AddOtaItemBtn && createOta) {
                <button
                  type="button"
                  (click)="submit()"
                  type="button"
                  class="submit-button"
                >
                  Submit <mat-icon class="btn-icon">check_circle</mat-icon>
                </button>
              }
              @if (UpdateOtaItem && updateOta) {
                <button
                  type="button"
                  (click)="updateItem()"
                  type="button"
                  class="edit-button"
                >
                  Update <mat-icon class="btn-icon">edit</mat-icon>
                </button>
              }
            </div>
          </div>
        </form>
      }
    </div>
  </div>
}
